export default async function slideware (state, appOptions, lastPage, pageOptions) {
  const Slideware = (await import(/* webpackChunkName: 'slideware' */ '../../apps/slideware')).default

  state.appStates.slideware.set(pageOptions)

  return new Slideware({
    state: state.appStates.slideware
  })
}
